export default class CancellationPolicy {
    public static Create(hours: number, percents: number) {
        return Object.assign(new CancellationPolicy(), { hours, percents })
    }
    hours: number = 0
    percents: number = 0
}
